export const appActionsList = {
  key: 'appActionsList',
  type: 'app',
  label: 'App Actions List',
  isCustom: true,
  path: 'suggestions.actions',
  shouldRun: ({ changes }) => {
    const appDocsChanged = changes?.filter((n) => n?.type === 'appDoc')?.length > 0;
    const newAction = !!changes?.find((n) => typeof n?.path === 'string' && /^actions\[[^\]]+\]$/.test(n.path));
    return appDocsChanged || newAction;
  },
  context: ['appDocs'],
  mapContext: ({ app, appDocs }) => {
    const existingAppActionNames = app?.actions?.map((n) => n?.name);
    const endpoints = appDocs?.endpoints;
    return {
      appName: app?.name,
      existingAppActionNames,
      endpoints
    };
  },
  postProcess: ({ suggestion, context, app }) => {
    const data = suggestion?.suggestion || {};
    const { suggestedValue } = data;

    const existingAppActionNames = app?.actions?.map((n) => n?.name);

    const docsEndpoints = context?.endpoints || [];
    const suggestedEndpoints = suggestedValue?.suggestedEndpoints || [];

    const filteredDocsEndpoints = docsEndpoints?.filter((n) => !existingAppActionNames?.includes(n?.suggestedActionName));
    const filteredSuggestedEndpoints = suggestedEndpoints?.filter((n) => !existingAppActionNames?.includes(n));

    const suggestedActions = filteredSuggestedEndpoints?.map((n) => filteredDocsEndpoints?.find((m) => m?.suggestedActionName === n));
    const otherActions = filteredDocsEndpoints?.filter((n) => !suggestedActions?.some((m) => m?.suggestedActionName === n?.suggestedActionName));

    return { ...suggestion, suggestion: { ...data, suggestedValue: { suggestedActions, otherActions } } };
  },
  prompt: 'appActionsList'
};
